import React from 'react';
import css from './SportsPage.module.css';
import { Field, Form } from 'react-final-form';
import { Icons } from '../../components';

const AutoSuggestion = ({
  handleInputChange,
  renderSuggestions,
  value,
  handleFocus,
  handleClearInput,
}) => {
  return (
    <Form
      onSubmit={() => {}}
      render={({}) => (
        <Field name="search">
          {({ input }) => (
            <div className={css.inputContainer}>
              <input
                {...input}
                type="text"
                value={value}
                onChange={event => {
                  input.onChange(event);
                  handleInputChange(event);
                }}
                autoComplete="off"
                onFocus={handleFocus}
                className={css.input}
                placeholder="Search for a sport"
              />
              {value && (
                <div className={css.clearIcon} onClick={handleClearInput}>
                  <Icons name="cross" />
                </div>
              )}
              {renderSuggestions()}
            </div>
          )}
        </Field>
      )}
    />
  );
};

export default AutoSuggestion;
